import { render, staticRenderFns } from "./activityTemplate.vue?vue&type=template&id=5782715a&scoped=true&"
import script from "./activityTemplate.vue?vue&type=script&lang=js&"
export * from "./activityTemplate.vue?vue&type=script&lang=js&"
import style0 from "./activityTemplate.vue?vue&type=style&index=0&id=5782715a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782715a",
  null
  
)

export default component.exports